var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        fullscreen: true,
        width: "100%",
        "custom-class": "transfer-order-modal",
        visible: _vm.openMapModal,
        "before-close": _vm.handleModalClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.openMapModal = $event
        },
      },
    },
    [
      _c(
        "span",
        {
          staticClass: "d-block",
          staticStyle: { "min-height": "86px" },
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c("h4", { staticClass: "m-0" }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("general.transfer")) +
                " " +
                _vm._s(
                  _vm.$t("planning.gMap.shipRefs") +
                    ": " +
                    _vm.selectedShipRefs.join(", ")
                ) +
                " "
            ),
          ]),
          !_vm.isViewOnly
            ? _c(
                "el-form",
                {
                  staticClass: "mt-3",
                  attrs: {
                    "label-position": "left",
                    "label-width": "4em",
                    inline: true,
                    size: "mini",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("general.from") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "ml-2",
                          staticStyle: { width: "500px" },
                          attrs: {
                            filterable: "",
                            multiple: "",
                            placeholder: _vm.$t(
                              "planning.placeholder.plateNumber"
                            ),
                          },
                          on: { change: _vm.handleFromTrucksChange },
                          model: {
                            value: _vm.fromTrucks,
                            callback: function ($$v) {
                              _vm.fromTrucks = $$v
                            },
                            expression: "fromTrucks",
                          },
                        },
                        _vm._l(_vm.$trucks, function (item, truckIndex) {
                          return _vm.truckIds.includes(item.id)
                            ? _c(
                                "el-option",
                                {
                                  key: item.id,
                                  attrs: {
                                    disabled:
                                      _vm.isTruckIdExistInGlobal(item.id) ||
                                      !_vm.isNotToTrucks(item.id),
                                    label: item.plateNumber,
                                    value: item.id,
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { float: "left" } },
                                    [_vm._v(_vm._s(item.plateNumber))]
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { float: "right" } },
                                    [_vm._v(_vm._s(item.vehicleType))]
                                  ),
                                ]
                              )
                            : _vm._e()
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "250px" },
                          attrs: {
                            size: "mini",
                            disabled:
                              _vm.fromPlanIds && _vm.fromPlanIds.length === 0,
                            filterable: "",
                            clearable: "",
                            placeholder: _vm.$t(
                              "planning.placeholder.printPlanId"
                            ),
                          },
                          on: { change: _vm.redrawMarkerOnly },
                          model: {
                            value: _vm.currentPlanId,
                            callback: function ($$v) {
                              _vm.currentPlanId = $$v
                            },
                            expression: "currentPlanId",
                          },
                        },
                        _vm._l(_vm.fromPlanIds, function (planId) {
                          return _c(
                            "el-option",
                            {
                              key: planId,
                              attrs: {
                                label: planId,
                                value: planId,
                                disabled:
                                  _vm.isPlanIdBelongToDifferentUser(planId),
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  style: { color: _vm.getPlanIdColor(planId) },
                                },
                                [_vm._v("●")]
                              ),
                              _vm._v(" " + _vm._s(planId) + " "),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "ml-5",
                      attrs: { label: _vm.$t("general.to") },
                    },
                    [
                      !_vm.helper.isUndefined(_vm.targetTruck)
                        ? _c(
                            "el-tooltip",
                            { attrs: { placement: "left" } },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("planning.columns.plateNumber")
                                      ) +
                                      ": " +
                                      _vm._s(
                                        _vm.getTruckInfo(_vm.targetTruck)
                                          .plateNumber || "-"
                                      )
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("planning.columns.vehicleType")
                                      ) +
                                      ": " +
                                      _vm._s(
                                        _vm.getTruckInfo(_vm.targetTruck)
                                          .vehicleType || "-"
                                      )
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("planning.columns.truckType")
                                      ) +
                                      ": " +
                                      _vm._s(
                                        _vm.getTruckInfo(_vm.targetTruck)
                                          .truckType
                                          ? "" +
                                              _vm.getTruckInfo(_vm.targetTruck)
                                                .truckType
                                          : "-"
                                      )
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "planning.columns.truckCommodityType"
                                        )
                                      ) +
                                      ": " +
                                      _vm._s(
                                        _vm.getTruckInfo(_vm.targetTruck)
                                          .truckCommodityType
                                          ? "" +
                                              _vm.getTruckInfo(_vm.targetTruck)
                                                .truckCommodityType
                                          : "-"
                                      )
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("planning.columns.brandName")
                                      ) +
                                      ": " +
                                      _vm._s(
                                        _vm.getTruckInfo(_vm.targetTruck)
                                          .brandName
                                          ? "" +
                                              _vm.getTruckInfo(_vm.targetTruck)
                                                .brandName
                                          : "-"
                                      )
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "planning.columns.weightCapacity"
                                        )
                                      ) +
                                      ": " +
                                      _vm._s(
                                        _vm.getTruckInfo(_vm.targetTruck).weight
                                          ? "" +
                                              _vm.helper.printThousandDecimal(
                                                _vm.getTruckInfo(
                                                  _vm.targetTruck
                                                ).weight
                                              )
                                          : 0
                                      )
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "planning.columns.volumeCapacity"
                                        )
                                      ) +
                                      ": " +
                                      _vm._s(
                                        _vm.getTruckInfo(_vm.targetTruck).volume
                                          ? "" +
                                              _vm.helper.printThousandDecimal(
                                                parseFloat(
                                                  _vm.getTruckInfo(
                                                    _vm.targetTruck
                                                  ).volume
                                                )
                                              )
                                          : 0
                                      )
                                  ),
                                  _c("br"),
                                ]
                              ),
                              _c("font-awesome-icon", {
                                style: {
                                  "margin-left": _vm.isAutoAssign ? "20px" : 0,
                                },
                                attrs: { icon: "info-circle" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-select",
                        {
                          staticClass: "ml-2",
                          staticStyle: { width: "250px" },
                          attrs: {
                            disabled:
                              _vm.isManualAssignLoading ||
                              _vm.isAutoAssignLoading,
                            filterable: "",
                            clearable: "",
                            placeholder: _vm.$t(
                              "planning.placeholder.plateNumber"
                            ),
                          },
                          on: { change: _vm.handleTargetTruckChange },
                          model: {
                            value: _vm.targetTruck,
                            callback: function ($$v) {
                              _vm.targetTruck = $$v
                            },
                            expression: "targetTruck",
                          },
                        },
                        _vm._l(_vm.$trucks, function (item) {
                          return _c(
                            "el-option",
                            {
                              key: item.id,
                              attrs: {
                                disabled:
                                  _vm.isTruckIdExistInGlobal(item.id) ||
                                  _vm.helper.includes(_vm.fromTrucks, item.id),
                                label: item.plateNumber,
                                value: item.id,
                              },
                            },
                            [
                              _c(
                                "span",
                                { staticStyle: { float: "left" } },
                                [
                                  _vm._v(" " + _vm._s(item.plateNumber) + " "),
                                  _vm.getRoutes(item.id).length
                                    ? [_vm._v(" ● ")]
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _c("span", { staticStyle: { float: "right" } }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      item.vehicleType +
                                        " " +
                                        (_vm.helper.isNotEmpty(
                                          item.truckCommodityType
                                        )
                                          ? ", " + item.truckCommodityType
                                          : "")
                                    ) +
                                    " "
                                ),
                              ]),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.targetTruck &&
                  _vm.getTruckPlanIdsByTruckId(_vm.targetTruck).length > 0
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                size: "mini",
                                filterable: "",
                                placeholder: _vm.$t(
                                  "planning.placeholder.printPlanId"
                                ),
                              },
                              model: {
                                value: _vm.targetPlanId,
                                callback: function ($$v) {
                                  _vm.targetPlanId = $$v
                                },
                                expression: "targetPlanId",
                              },
                            },
                            [
                              _vm._l(
                                _vm.getTruckPlanIdsByTruckId(_vm.targetTruck),
                                function (planId) {
                                  return _c("el-option", {
                                    key: planId,
                                    attrs: {
                                      disabled:
                                        _vm.isPlanIdBelongToDifferentUser(
                                          planId,
                                          _vm.targetTruck
                                        ),
                                      label: planId,
                                      value: planId,
                                    },
                                  })
                                }
                              ),
                              _c("el-option", {
                                attrs: {
                                  label: _vm.$t("planning.createNewPlanId"),
                                  value: "newPlanId",
                                },
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { staticClass: "ml-5" },
                    [
                      _c("el-tooltip", { attrs: { placement: "top" } }, [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _vm.isTransferLoadPlanDisabled
                              ? [
                                  _vm.$anyChanges
                                    ? [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.messages.saveBeforeSwitchTruck"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    : _vm._e(),
                                  this.selectedShipRefs.length === 0
                                    ? [
                                        _vm._v(
                                          " · " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.tooltip.noWpSelected"
                                              )
                                            )
                                        ),
                                        _c("br"),
                                      ]
                                    : _vm._e(),
                                  this.fromTrucks.length === 0
                                    ? [
                                        _vm._v(
                                          " · " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.tooltip.fromTruckEmpty"
                                              )
                                            )
                                        ),
                                        _c("br"),
                                      ]
                                    : _vm._e(),
                                  !this.targetTruck
                                    ? [
                                        _vm._v(
                                          " · " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.tooltip.targetTruckNotSelected"
                                              )
                                            )
                                        ),
                                        _c("br"),
                                      ]
                                    : _vm._e(),
                                  !this.targetPlanId
                                    ? [
                                        _vm._v(
                                          " · " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.tooltip.targetTruckNoPlanId"
                                              )
                                            )
                                        ),
                                        _c("br"),
                                      ]
                                    : _vm._e(),
                                  this.areSomeRoutesStatusCompleted
                                    ? [
                                        _vm._v(
                                          " · " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.tooltip.areSomeRoutesStatusCompleted"
                                              )
                                            )
                                        ),
                                        _c("br"),
                                      ]
                                    : _vm._e(),
                                  this.hasCompletedWaypoint
                                    ? [
                                        _vm._v(
                                          " · " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.tooltip.hasCompletedWaypoint"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    : _vm._e(),
                                  this.isTargetTruckRoutesAssignedCompleted
                                    ? [
                                        _vm._v(
                                          " · " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.tooltip.areSomeTargetRoutesStatusCompleted"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    : _vm._e(),
                                ]
                              : [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("planning.transferOrder")) +
                                      " "
                                  ),
                                ],
                          ],
                          2
                        ),
                        _c(
                          "span",
                          { staticClass: "disabled-btn-wrapper" },
                          [
                            _c(
                              "el-button",
                              {
                                staticClass: "float-right ml-3",
                                attrs: {
                                  disabled: _vm.isTransferLoadPlanDisabled,
                                  type: "success",
                                  size: "small",
                                },
                                on: { click: _vm.transferOrder },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("general.confirmTransferOrder")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { staticClass: "d-none d-md-inline-block" },
                    [
                      _c(
                        "span",
                        { staticClass: "disabled-btn-wrapper" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                disabled:
                                  !_vm.$anyChanges ||
                                  _vm.isManualAssignLoading ||
                                  _vm.isAutoAssignLoading,
                                type: "primary",
                                size: "small",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.saveTransferredPlan()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("planning.savePlan")) + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c("el-tooltip", { attrs: { placement: "top" } }, [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _vm.isRemoveOrdersDisabled
                              ? [
                                  _vm.$anyChanges
                                    ? [
                                        _vm._v(
                                          " · " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.tooltip.unsavedChanges"
                                              )
                                            )
                                        ),
                                        _c("br"),
                                      ]
                                    : _vm._e(),
                                  this.selectedShipRefs.length === 0
                                    ? [
                                        _vm._v(
                                          " · " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.tooltip.noWpSelected"
                                              )
                                            )
                                        ),
                                        _c("br"),
                                      ]
                                    : _vm._e(),
                                  this.hasCompletedWaypoint
                                    ? [
                                        _vm._v(
                                          " · " +
                                            _vm._s(
                                              _vm.$t(
                                                "planning.tooltip.hasCompletedWaypoint"
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    : _vm._e(),
                                ]
                              : [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("planning.removeOrders")) +
                                      " "
                                  ),
                                ],
                          ],
                          2
                        ),
                        _c(
                          "span",
                          { staticClass: "disabled-btn-wrapper" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "danger",
                                  size: "small",
                                  disabled: _vm.isRemoveOrdersDisabled,
                                },
                                on: { click: _vm.removeOrders },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("planning.removeOrders")) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      !_vm.isViewOnly
        ? _c(
            "div",
            { staticClass: "floating-box-drawing transfer-plan" },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    placement: "right",
                    content: _vm.$t("planning.drawPolygon"),
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "item-container",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.drawPolygon()
                        },
                      },
                    },
                    [
                      _c("font-awesome-icon", {
                        staticClass: "item-title",
                        attrs: { icon: "pen" },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.isLoading
        ? _c("div", { staticClass: "loader-container" }, [
            _c("div", { staticClass: "loader" }),
          ])
        : [
            _c(
              "el-row",
              { staticClass: "plan-assign", attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 16 } },
                  [
                    _vm.mapPoints.length >= 1
                      ? _c("map-world", {
                          ref: "mapWorld",
                          attrs: {
                            locations: _vm.location,
                            routes: _vm.mapPoints,
                            plan: _vm.$plan,
                            selectedShipRefs: _vm.selectedShipRefs,
                            "init-event": "polylines",
                          },
                          on: {
                            polygonComplete: _vm.handlePolygonComplete,
                            selectShipRef: _vm.handleSelectShipRef,
                            onColorByPlanIdChange:
                              _vm.handleColorByPlanIdChange,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  {
                    staticClass: "marker-dialog",
                    attrs: { xs: 24, sm: 24, md: 8 },
                  },
                  [
                    _c(
                      "el-row",
                      {
                        staticStyle: { "margin-bottom": "24px" },
                        attrs: { gutter: 20 },
                      },
                      [
                        _c("el-col", { attrs: { xs: 24, sm: 24, md: 24 } }, [
                          _c(
                            "h4",
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("general.from")) + ": "
                              ),
                              _vm.fromTrucks.length
                                ? _vm._l(
                                    _vm.fromTrucks,
                                    function (truckId, index) {
                                      return _c(
                                        "span",
                                        {
                                          key: index,
                                          class: index === 0 ? "ml-3" : "ml-1",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getTruckInfo(truckId)
                                                  .plateNumber
                                              )
                                          ),
                                          index !== _vm.fromTrucks.length - 1
                                            ? [_vm._v(",")]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    }
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _c(
                            "div",
                            { staticClass: "transfer-truck-container" },
                            [
                              _c(
                                "draggable",
                                _vm._b(
                                  {
                                    staticClass: "list-group",
                                    staticStyle: { padding: "0" },
                                    attrs: {
                                      disabled: _vm.isDragRouteDisabled,
                                      tag: "ul",
                                    },
                                    on: {
                                      change: _vm.handleRouteDrag,
                                      update: function ($event) {
                                        _vm.$anyChanges = true
                                      },
                                    },
                                    model: {
                                      value: _vm.mapPoints,
                                      callback: function ($$v) {
                                        _vm.mapPoints = $$v
                                      },
                                      expression: "mapPoints",
                                    },
                                  },
                                  "draggable",
                                  _vm.dragOptions,
                                  false
                                ),
                                [
                                  _c(
                                    "transition-group",
                                    {
                                      attrs: {
                                        type: "transition",
                                        name: "flip-list",
                                      },
                                    },
                                    _vm._l(
                                      _vm.mapPoints,
                                      function (route, routeIndex) {
                                        return route && route.isFrom
                                          ? _c(
                                              "li",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.currentPlanId
                                                      ? route.planId ===
                                                        _vm.currentPlanId
                                                      : true,
                                                    expression:
                                                      "currentPlanId ? route.planId === currentPlanId : true",
                                                  },
                                                ],
                                                key: "" + route.masterpointId,
                                                staticClass:
                                                  "list-group-item cursor-pointer",
                                                class: _vm.getRouteClass(
                                                  route,
                                                  routeIndex
                                                ),
                                                style:
                                                  _vm.getRouteStyles(route),
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.selectShipRef(
                                                      route
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-row",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          _vm.isShowPlateNumber(
                                                            {
                                                              route: route,
                                                              routeIndex:
                                                                routeIndex,
                                                            }
                                                          ),
                                                        expression:
                                                          "isShowPlateNumber({ route, routeIndex })",
                                                      },
                                                    ],
                                                    staticClass: "mb-2",
                                                    attrs: { type: "flex" },
                                                  },
                                                  [
                                                    _c(
                                                      "el-col",
                                                      { attrs: { span: 24 } },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.getPlateNumber(
                                                                { route: route }
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-row",
                                                  { attrs: { type: "flex" } },
                                                  [
                                                    _c(
                                                      "el-col",
                                                      {
                                                        staticStyle: {
                                                          width: "45px",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "point-index",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getRouteIndex(
                                                                  route,
                                                                  true
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                        route.waypointType ===
                                                        "P"
                                                          ? _c(
                                                              "font-awesome-icon",
                                                              {
                                                                staticClass:
                                                                  "point-type",
                                                                staticStyle: {
                                                                  "margin-left":
                                                                    "14px",
                                                                },
                                                                attrs: {
                                                                  icon: "circle",
                                                                  "aria-hidden":
                                                                    "true",
                                                                  size: "lg",
                                                                },
                                                              }
                                                            )
                                                          : _c(
                                                              "font-awesome-icon",
                                                              {
                                                                staticClass:
                                                                  "point-type",
                                                                staticStyle: {
                                                                  "margin-left":
                                                                    "16px",
                                                                },
                                                                attrs: {
                                                                  icon: "map-marker",
                                                                  "aria-hidden":
                                                                    "true",
                                                                  size: "lg",
                                                                },
                                                              }
                                                            ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "el-col",
                                                      {
                                                        staticClass:
                                                          "route-container",
                                                      },
                                                      [
                                                        _vm.isPlanIdBelongToDifferentUser(
                                                          route.planId
                                                        )
                                                          ? _c(
                                                              "div",
                                                              [
                                                                _c(
                                                                  "font-awesome-icon",
                                                                  {
                                                                    attrs: {
                                                                      icon: [
                                                                        "far",
                                                                        "eye",
                                                                      ],
                                                                      size: "lg",
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "ml-2 mb-2 d-inline-block",
                                                                  },
                                                                  [
                                                                    _c("i", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "planning.viewOnly"
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]),
                                                                    _c(
                                                                      "b",
                                                                      {
                                                                        staticClass:
                                                                          "ml-1",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "- " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "general.createdBy"
                                                                              )
                                                                            ) +
                                                                            ":"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.getUsername(
                                                                            _vm.routes,
                                                                            route.planId
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _vm._e(),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "align-top",
                                                          },
                                                          [
                                                            route.locked ||
                                                            route.status.toUpperCase() ===
                                                              "COMPLETED"
                                                              ? _c(
                                                                  "font-awesome-icon",
                                                                  {
                                                                    attrs: {
                                                                      icon: "lock",
                                                                    },
                                                                  }
                                                                )
                                                              : _vm._e(),
                                                            _c(
                                                              "el-tooltip",
                                                              {
                                                                attrs: {
                                                                  placement:
                                                                    "bottom-start",
                                                                  "popper-options":
                                                                    _vm.popperOptions,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    attrs: {
                                                                      slot: "content",
                                                                    },
                                                                    slot: "content",
                                                                  },
                                                                  [
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.columns.status"
                                                                            )
                                                                          ) +
                                                                            ": "
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          route.status.toUpperCase()
                                                                        )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.gMap.waypointType"
                                                                            )
                                                                          ) +
                                                                            ":"
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.waypointType." +
                                                                                route.waypointType
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.columns.zone"
                                                                            )
                                                                          ) +
                                                                            ": "
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          route.zone ===
                                                                            ""
                                                                            ? "-"
                                                                            : route.zone
                                                                        )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.gMap.district"
                                                                            )
                                                                          ) +
                                                                            ":"
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            route.district ===
                                                                              ""
                                                                              ? "-"
                                                                              : route.district
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.tooltip.address"
                                                                            )
                                                                          ) +
                                                                            ":"
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.getWaypointFromId(
                                                                              route.masterpointId,
                                                                              "address1"
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "general.createdBy"
                                                                            )
                                                                          ) +
                                                                            ":"
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            !_vm.helper.isUndefined(
                                                                              route.user
                                                                            )
                                                                              ? route.user
                                                                              : _vm
                                                                                  .$userInformation
                                                                                  .user
                                                                                  .name
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.tooltip.companyName"
                                                                            )
                                                                          ) +
                                                                            ":"
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.getWaypointFromId(
                                                                              route.masterpointId,
                                                                              "companyName"
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("hr"),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.tooltip.start"
                                                                            )
                                                                          ) +
                                                                            ":"
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm._f(
                                                                              "convertTimezone"
                                                                            )(
                                                                              route.startTime,
                                                                              _vm.$timezone
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.tooltip.travellingTime"
                                                                            )
                                                                          ) +
                                                                            ": "
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.helper.printThousandDecimal(
                                                                            route.time /
                                                                              60
                                                                          )
                                                                        ) +
                                                                          " " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.tooltip.minutes"
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            route.status.toUpperCase() ===
                                                                              "COMPLETED"
                                                                              ? _vm.$t(
                                                                                  "planning.tooltip.arrivalTime"
                                                                                )
                                                                              : _vm.$t(
                                                                                  "planning.tooltip.eta"
                                                                                )
                                                                          ) +
                                                                            ": "
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "convertTimezone"
                                                                          )(
                                                                            route.estimateTime,
                                                                            _vm.$timezone
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.tooltip.processingTime"
                                                                            )
                                                                          ) +
                                                                            ": "
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.helper.printThousandDecimal(
                                                                            route.processingTime /
                                                                              60
                                                                          )
                                                                        ) +
                                                                          " " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.tooltip.minutes"
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            route.status.toUpperCase() ===
                                                                              "COMPLETED"
                                                                              ? _vm.$t(
                                                                                  "planning.tooltip.end"
                                                                                )
                                                                              : _vm.$t(
                                                                                  "planning.tooltip.expectedEnd"
                                                                                )
                                                                          ) +
                                                                            ": "
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "convertTimezone"
                                                                          )(
                                                                            route.endTime,
                                                                            _vm.$timezone
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.tooltip.actualFinishDate"
                                                                            )
                                                                          ) +
                                                                            ":"
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.getActualFinishDate(
                                                                              route
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]),
                                                                    _c("hr"),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.columns.planId"
                                                                            )
                                                                          ) +
                                                                            ":"
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            route.planId
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.columns.projectCode"
                                                                            )
                                                                          ) +
                                                                            ":"
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.getOrderField(
                                                                              _vm.getOrderId(
                                                                                route
                                                                              ),
                                                                              "projectCode"
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.columns.customerCode"
                                                                            )
                                                                          ) +
                                                                            ":"
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.getOrderField(
                                                                              _vm.getOrderId(
                                                                                route
                                                                              ),
                                                                              "customerCode"
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.columns.shipmentReference"
                                                                            )
                                                                          ) +
                                                                            ":"
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            route.shipmentReference
                                                                              ? route.shipmentReference.join(
                                                                                  ", "
                                                                                )
                                                                              : ""
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.tooltip.qty"
                                                                            )
                                                                          ) +
                                                                            ":"
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.getOrderField(
                                                                              _vm.getOrderId(
                                                                                route
                                                                              ),
                                                                              "quantity"
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.tooltip.gw"
                                                                            )
                                                                          ) +
                                                                            ":"
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.getOrderField(
                                                                              _vm.getOrderId(
                                                                                route
                                                                              ),
                                                                              "weight"
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.tooltip.cbm"
                                                                            )
                                                                          ) +
                                                                            ":"
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.getOrderField(
                                                                              _vm.getOrderId(
                                                                                route
                                                                              ),
                                                                              "volume"
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.tooltip.serviceType"
                                                                            )
                                                                          ) +
                                                                            ":"
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.getOrderField(
                                                                              _vm.getOrderId(
                                                                                route
                                                                              ),
                                                                              "serviceType"
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c("div", [
                                                                      _c("b", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.tooltip.commodityType"
                                                                            )
                                                                          ) +
                                                                            ":"
                                                                        ),
                                                                      ]),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.getOrderField(
                                                                              _vm.getOrderId(
                                                                                route
                                                                              ),
                                                                              "commodityType"
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]),
                                                                    _c(
                                                                      "div",
                                                                      [
                                                                        _c(
                                                                          "b",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "planning.columns.remarks"
                                                                                )
                                                                              ) +
                                                                                ":"
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._l(
                                                                          _vm.getOrdersField(
                                                                            route.orderId,
                                                                            "remarks"
                                                                          ),
                                                                          function (
                                                                            item,
                                                                            remarksIndex
                                                                          ) {
                                                                            return _c(
                                                                              "div",
                                                                              {
                                                                                key: remarksIndex,
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticClass:
                                                                                      "break-word",
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "• " +
                                                                                        _vm._s(
                                                                                          item
                                                                                        )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            )
                                                                          }
                                                                        ),
                                                                      ],
                                                                      2
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "font-awesome-icon",
                                                                  {
                                                                    attrs: {
                                                                      icon: "info-circle",
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "break-word d-inline-block display-address ml-1",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "d-inline-block",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getTimeWindow(
                                                                        route
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            route
                                                              .shipmentReference
                                                              .length > 1
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "d-inline-block ml-1",
                                                                  },
                                                                  [
                                                                    _c("i", [
                                                                      _vm._v(
                                                                        "- (" +
                                                                          _vm._s(
                                                                            route
                                                                              .shipmentReference
                                                                              .length
                                                                          ) +
                                                                          " " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "planning.tooltip.shipRefs"
                                                                            )
                                                                          ) +
                                                                          ")"
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            route
                                                              .shipmentReference
                                                              .length === 1
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "d-inline-block ml-1",
                                                                  },
                                                                  [
                                                                    _c("i", [
                                                                      _vm._v(
                                                                        "- (" +
                                                                          _vm._s(
                                                                            route
                                                                              .shipmentReference[0]
                                                                          ) +
                                                                          ")"
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "position-relative",
                                                            staticStyle: {
                                                              top: "-8px",
                                                            },
                                                          },
                                                          [
                                                            _vm.hasAssemblyMinutes
                                                              ? [
                                                                  _vm._l(
                                                                    _vm.getOrdersField(
                                                                      route.orderId,
                                                                      "remarks"
                                                                    ),
                                                                    function (
                                                                      item,
                                                                      remarksIndex
                                                                    ) {
                                                                      return _c(
                                                                        "div",
                                                                        {
                                                                          key: remarksIndex,
                                                                          staticClass:
                                                                            "break-word",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "break-word",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "• " +
                                                                                  _vm._s(
                                                                                    item
                                                                                  )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    }
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "break-word",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.getOrderField(
                                                                            _vm.getOrderId(
                                                                              route
                                                                            ),
                                                                            "serviceName"
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              : _vm._e(),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "break-word",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    route.displayAddress
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                class:
                                                                  _vm.isRouteLate(
                                                                    route
                                                                  ),
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "planning.tooltip.eta"
                                                                    )
                                                                  ) +
                                                                    ": " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "convertTimezone"
                                                                      )(
                                                                        route.estimateTime,
                                                                        _vm.$timezone
                                                                      )
                                                                    )
                                                                ),
                                                              ]
                                                            ),
                                                            _c("div", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "planning.tooltip.actualFinishDate"
                                                                    )
                                                                  ) +
                                                                  ": " +
                                                                  _vm._s(
                                                                    _vm.getActualFinishDate(
                                                                      route
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]),
                                                          ],
                                                          2
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      }
                                    ),
                                    0
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "el-col",
                          {
                            staticStyle: { "margin-top": "20px" },
                            attrs: { xs: 24, sm: 24, md: 24 },
                          },
                          [
                            _c("h4", [
                              _vm._v(" " + _vm._s(_vm.$t("general.to")) + ": "),
                              _vm.targetTruck
                                ? _c("span", { staticClass: "ml-4" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getTruckInfo(_vm.targetTruck)
                                            .plateNumber
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                            _c(
                              "div",
                              { staticClass: "transfer-truck-container" },
                              _vm._l(
                                _vm.getRoutes(_vm.targetTruck),
                                function (route, routeIndex) {
                                  return _vm.targetTruck &&
                                    _vm.getRoutes(_vm.targetTruck).length > 0
                                    ? _c(
                                        "li",
                                        {
                                          key: "" + route.masterpointId,
                                          staticClass: "list-group-item",
                                          class: _vm.getTargetRouteClass(route),
                                          style:
                                            _vm.getTargetRouteStyles(route),
                                        },
                                        [
                                          _c(
                                            "el-row",
                                            { attrs: { type: "flex" } },
                                            [
                                              _c(
                                                "el-col",
                                                {
                                                  staticStyle: {
                                                    width: "45px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "point-index",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getRouteIndex(
                                                            route,
                                                            false
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  route.waypointType === "P"
                                                    ? _c("font-awesome-icon", {
                                                        staticClass:
                                                          "point-type",
                                                        staticStyle: {
                                                          "margin-left": "14px",
                                                        },
                                                        attrs: {
                                                          icon: "circle",
                                                          "aria-hidden": "true",
                                                          size: "lg",
                                                        },
                                                      })
                                                    : _c("font-awesome-icon", {
                                                        staticClass:
                                                          "point-type",
                                                        staticStyle: {
                                                          "margin-left": "16px",
                                                        },
                                                        attrs: {
                                                          icon: "map-marker",
                                                          "aria-hidden": "true",
                                                          size: "lg",
                                                        },
                                                      }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                {
                                                  staticClass:
                                                    "route-container",
                                                },
                                                [
                                                  _vm.isPlanIdBelongToDifferentUser(
                                                    route.planId,
                                                    _vm.targetTruck
                                                  )
                                                    ? _c(
                                                        "div",
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon: [
                                                                  "far",
                                                                  "eye",
                                                                ],
                                                                size: "lg",
                                                              },
                                                            }
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "ml-2 mb-2 d-inline-block",
                                                            },
                                                            [
                                                              _c("i", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "planning.viewOnly"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _c(
                                                                "b",
                                                                {
                                                                  staticClass:
                                                                    "ml-1",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "- " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "general.createdBy"
                                                                        )
                                                                      ) +
                                                                      ":"
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.getUsername(
                                                                      _vm.getRoutes(
                                                                        _vm.targetTruck
                                                                      ),
                                                                      route.planId
                                                                    )
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "align-top",
                                                    },
                                                    [
                                                      route.locked ||
                                                      route.status.toUpperCase() ===
                                                        "COMPLETED"
                                                        ? _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon: "lock",
                                                              },
                                                            }
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "el-tooltip",
                                                        {
                                                          attrs: {
                                                            placement:
                                                              "bottom-end",
                                                            "popper-options":
                                                              _vm.popperOptions,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              attrs: {
                                                                slot: "content",
                                                              },
                                                              slot: "content",
                                                            },
                                                            [
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.columns.status"
                                                                      )
                                                                    ) + ": "
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  _vm._s(
                                                                    route.status.toUpperCase()
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.gMap.waypointType"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.waypointType." +
                                                                          route.waypointType
                                                                      )
                                                                    )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.columns.zone"
                                                                      )
                                                                    ) + ": "
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  _vm._s(
                                                                    route.zone ===
                                                                      ""
                                                                      ? "-"
                                                                      : route.zone
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.gMap.district"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      route.district ===
                                                                        ""
                                                                        ? "-"
                                                                        : route.district
                                                                    )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.tooltip.address"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getWaypointFromId(
                                                                        route.masterpointId,
                                                                        "address1"
                                                                      )
                                                                    )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "general.createdBy"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      !_vm.helper.isUndefined(
                                                                        route.user
                                                                      )
                                                                        ? route.user
                                                                        : _vm
                                                                            .$userInformation
                                                                            .user
                                                                            .name
                                                                    )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.tooltip.companyName"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getWaypointFromId(
                                                                        route.masterpointId,
                                                                        "companyName"
                                                                      )
                                                                    )
                                                                ),
                                                              ]),
                                                              _c("hr"),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.tooltip.start"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "convertTimezone"
                                                                      )(
                                                                        route.startTime,
                                                                        _vm.$timezone
                                                                      )
                                                                    )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.tooltip.travellingTime"
                                                                      )
                                                                    ) + ": "
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.helper.printThousandDecimal(
                                                                      route.time /
                                                                        60
                                                                    )
                                                                  ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.tooltip.minutes"
                                                                      )
                                                                    )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      route.status.toUpperCase() ===
                                                                        "COMPLETED"
                                                                        ? _vm.$t(
                                                                            "planning.tooltip.arrivalTime"
                                                                          )
                                                                        : _vm.$t(
                                                                            "planning.tooltip.eta"
                                                                          )
                                                                    ) + ": "
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "convertTimezone"
                                                                    )(
                                                                      route.estimateTime,
                                                                      _vm.$timezone
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.tooltip.processingTime"
                                                                      )
                                                                    ) + ": "
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.helper.printThousandDecimal(
                                                                      route.processingTime /
                                                                        60
                                                                    )
                                                                  ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.tooltip.minutes"
                                                                      )
                                                                    )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      route.status.toUpperCase() ===
                                                                        "COMPLETED"
                                                                        ? _vm.$t(
                                                                            "planning.tooltip.end"
                                                                          )
                                                                        : _vm.$t(
                                                                            "planning.tooltip.expectedEnd"
                                                                          )
                                                                    ) + ": "
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "convertTimezone"
                                                                    )(
                                                                      route.endTime,
                                                                      _vm.$timezone
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.tooltip.actualFinishDate"
                                                                      )
                                                                    ) +
                                                                    ": "
                                                                ),
                                                                _vm.getWaypointFromId(
                                                                  route.masterpointId,
                                                                  "completedTime"
                                                                ) ===
                                                                "0000-00-00 00:00:00"
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        " - "
                                                                      ),
                                                                    ])
                                                                  : _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "convertTimezone"
                                                                          )(
                                                                            _vm.getWaypointFromId(
                                                                              route.masterpointId,
                                                                              "completedTime"
                                                                            ),
                                                                            _vm.$timezone
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]),
                                                              ]),
                                                              _c("hr"),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.columns.planId"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      route.planId
                                                                    )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.columns.projectCode"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getOrderField(
                                                                        _vm.getOrderId(
                                                                          route
                                                                        ),
                                                                        "projectCode"
                                                                      )
                                                                    )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.columns.customerCode"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getOrderField(
                                                                        _vm.getOrderId(
                                                                          route
                                                                        ),
                                                                        "customerCode"
                                                                      )
                                                                    )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.columns.shipmentReference"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      route.shipmentReference
                                                                        ? route.shipmentReference.join(
                                                                            ", "
                                                                          )
                                                                        : ""
                                                                    )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.tooltip.qty"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getOrderField(
                                                                        _vm.getOrderId(
                                                                          route
                                                                        ),
                                                                        "quantity"
                                                                      )
                                                                    )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.tooltip.gw"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getOrderField(
                                                                        _vm.getOrderId(
                                                                          route
                                                                        ),
                                                                        "weight"
                                                                      )
                                                                    )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.tooltip.cbm"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getOrderField(
                                                                        _vm.getOrderId(
                                                                          route
                                                                        ),
                                                                        "volume"
                                                                      )
                                                                    )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.tooltip.serviceType"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getOrderField(
                                                                        _vm.getOrderId(
                                                                          route
                                                                        ),
                                                                        "serviceType"
                                                                      )
                                                                    )
                                                                ),
                                                              ]),
                                                              _c("div", [
                                                                _c("b", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.tooltip.commodityType"
                                                                      )
                                                                    ) + ":"
                                                                  ),
                                                                ]),
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.getOrderField(
                                                                        _vm.getOrderId(
                                                                          route
                                                                        ),
                                                                        "commodityType"
                                                                      )
                                                                    )
                                                                ),
                                                              ]),
                                                              _c(
                                                                "div",
                                                                [
                                                                  _c("b", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "planning.columns.remarks"
                                                                        )
                                                                      ) + ":"
                                                                    ),
                                                                  ]),
                                                                  _vm._l(
                                                                    _vm.getOrdersField(
                                                                      route.orderId,
                                                                      "remarks"
                                                                    ),
                                                                    function (
                                                                      item,
                                                                      remarksIndex
                                                                    ) {
                                                                      return _c(
                                                                        "div",
                                                                        {
                                                                          key: remarksIndex,
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "break-word",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "• " +
                                                                                  _vm._s(
                                                                                    item
                                                                                  )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    }
                                                                  ),
                                                                ],
                                                                2
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon: "info-circle",
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "break-word d-inline-block display-address ml-1",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-inline-block",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "convertTimezone"
                                                                )(
                                                                  _vm.getWaypointFromId(
                                                                    route.masterpointId,
                                                                    "startTime"
                                                                  ),
                                                                  _vm.$timezone,
                                                                  "YY-MM-DD"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.getStartAndEndTime(
                                                                  route.waypointId
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                      route.shipmentReference
                                                        .length > 1
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-inline-block ml-1",
                                                            },
                                                            [
                                                              _c("i", [
                                                                _vm._v(
                                                                  "- (" +
                                                                    _vm._s(
                                                                      route
                                                                        .shipmentReference
                                                                        .length
                                                                    ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "planning.tooltip.shipRefs"
                                                                      )
                                                                    ) +
                                                                    ")"
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      route.shipmentReference
                                                        .length === 1
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "d-inline-block ml-1",
                                                            },
                                                            [
                                                              _c("i", [
                                                                _vm._v(
                                                                  "- (" +
                                                                    _vm._s(
                                                                      route
                                                                        .shipmentReference[0]
                                                                    ) +
                                                                    ")"
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "position-relative",
                                                      staticStyle: {
                                                        top: "-8px",
                                                      },
                                                    },
                                                    [
                                                      _vm.hasAssemblyMinutes
                                                        ? [
                                                            _vm._l(
                                                              _vm.getOrdersField(
                                                                route.orderId,
                                                                "remarks"
                                                              ),
                                                              function (
                                                                item,
                                                                remarksIndex
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key: remarksIndex,
                                                                    staticClass:
                                                                      "break-word",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "break-word",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "• " +
                                                                            _vm._s(
                                                                              item
                                                                            )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "break-word",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getOrderField(
                                                                      _vm.getOrderId(
                                                                        route
                                                                      ),
                                                                      "serviceName"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        : _vm._e(),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "break-word",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              route.displayAddress
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          class:
                                                            _vm.isRouteLate(
                                                              route
                                                            ),
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.tooltip.eta"
                                                              )
                                                            ) +
                                                              ": " +
                                                              _vm._s(
                                                                _vm._f(
                                                                  "convertTimezone"
                                                                )(
                                                                  route.estimateTime,
                                                                  _vm.$timezone
                                                                )
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _c("div", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "planning.tooltip.actualFinishDate"
                                                              )
                                                            ) +
                                                            ": "
                                                        ),
                                                        _vm.getWaypointFromId(
                                                          route.masterpointId,
                                                          "completedTime"
                                                        ) ===
                                                        "0000-00-00 00:00:00"
                                                          ? _c("span", [
                                                              _vm._v(" - "),
                                                            ])
                                                          : _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "convertTimezone"
                                                                  )(
                                                                    _vm.getWaypointFromId(
                                                                      route.masterpointId,
                                                                      "completedTime"
                                                                    ),
                                                                    _vm.$timezone
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                      ]),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                }
                              ),
                              0
                            ),
                          ]
                        ),
                        !_vm.isViewOnly
                          ? _c(
                              "el-col",
                              {
                                staticClass: "mt-10",
                                attrs: { xs: 24, sm: 24, md: 24 },
                              },
                              [
                                _c(
                                  "el-tooltip",
                                  { attrs: { placement: "top" } },
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { slot: "content" },
                                        slot: "content",
                                      },
                                      [
                                        _vm.isTransferLoadPlanDisabled
                                          ? [
                                              _vm.$anyChanges
                                                ? [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "planning.messages.saveBeforeSwitchTruck"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                : _vm._e(),
                                              this.selectedShipRefs.length === 0
                                                ? [
                                                    _vm._v(
                                                      " · " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "planning.tooltip.noWpSelected"
                                                          )
                                                        )
                                                    ),
                                                    _c("br"),
                                                  ]
                                                : _vm._e(),
                                              this.fromTrucks.length === 0
                                                ? [
                                                    _vm._v(
                                                      " · " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "planning.tooltip.fromTruckEmpty"
                                                          )
                                                        )
                                                    ),
                                                    _c("br"),
                                                  ]
                                                : _vm._e(),
                                              !this.targetTruck
                                                ? [
                                                    _vm._v(
                                                      " · " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "planning.tooltip.targetTruckNotSelected"
                                                          )
                                                        )
                                                    ),
                                                    _c("br"),
                                                  ]
                                                : _vm._e(),
                                              !this.targetPlanId
                                                ? [
                                                    _vm._v(
                                                      " · " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "planning.tooltip.targetTruckNoPlanId"
                                                          )
                                                        )
                                                    ),
                                                    _c("br"),
                                                  ]
                                                : _vm._e(),
                                              this.areSomeRoutesStatusCompleted
                                                ? [
                                                    _vm._v(
                                                      " · " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "planning.tooltip.areSomeRoutesStatusCompleted"
                                                          )
                                                        )
                                                    ),
                                                    _c("br"),
                                                  ]
                                                : _vm._e(),
                                              this.hasCompletedWaypoint
                                                ? [
                                                    _vm._v(
                                                      " · " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "planning.tooltip.hasCompletedWaypoint"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                : _vm._e(),
                                              this
                                                .isTargetTruckRoutesAssignedCompleted
                                                ? [
                                                    _vm._v(
                                                      " · " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "planning.tooltip.areSomeTargetRoutesStatusCompleted"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ]
                                          : [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "planning.transferOrder"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ],
                                      ],
                                      2
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "disabled-btn-wrapper float-right ml-3 mr-2",
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              disabled:
                                                _vm.isTransferLoadPlanDisabled,
                                              type: "success",
                                              size: "small",
                                            },
                                            on: { click: _vm.transferOrder },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "general.confirmTransferOrder"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "float-right",
                                    attrs: { size: "small" },
                                    on: { click: _vm.handleModalClose },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("general.cancel")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "h1",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.fromTrucks.length && !_vm.targetTruck,
                    expression: "!fromTrucks.length && !targetTruck",
                  },
                ],
                staticClass: "text-center",
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("planning.tooltip.assignTruckWarning3")) +
                    " "
                ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }